export default __webpack_public_path__ + "static/media/thane2.ee1baf40.jpg";